import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoginFormComponent, MdefLoginFormComponent } from 'component-library';
import { AuthenticationConfig, AuthService, User } from 'shared';

import { NavigationService } from '../auth/navigation/navigation.service';

@Component({
  selector: 'tngh-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoginFormComponent, MdefLoginFormComponent],
})
export class LoginComponent {
  private readonly authService = inject(AuthService);
  private readonly config = inject(AuthenticationConfig);
  private readonly destroyRef = inject(DestroyRef);
  private readonly navigationService = inject(NavigationService);

  loginError = false;
  showFormErrors = false;
  theme: AuthenticationConfig['theme'];

  constructor() {
    this.theme = this.config.theme ?? 'tngh';
  }

  doLogin(user: User) {
    this.loginError = false;
    this.authService
      .login(user.emailAddress, user.password)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.navigationService.back();
        },
        error: () => (this.loginError = true),
      });
  }

  navigateToPasswordReset() {
    this.navigationService.passwordResetRequest();
  }
}
